"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "m8.189 11.996-4.7-4.732A1.636 1.636 0 0 1 3 6.08a1.61 1.61 0 0 1 .489-1.2 1.62 1.62 0 0 1 1.193-.482c.474 0 .871.16 1.192.482l5.907 5.907c.165.165.29.353.374.564a1.734 1.734 0 0 1 0 1.293 1.66 1.66 0 0 1-.374.564l-5.907 5.907a1.636 1.636 0 0 1-1.185.489 1.61 1.61 0 0 1-1.2-.489 1.62 1.62 0 0 1-.482-1.193c0-.474.16-.872.482-1.192l4.7-4.732Zm8.737 0-4.718-4.732a1.636 1.636 0 0 1-.489-1.185 1.61 1.61 0 0 1 .489-1.2 1.62 1.62 0 0 1 1.193-.482c.474 0 .872.16 1.193.482l5.906 5.907c.165.165.29.353.374.564a1.734 1.734 0 0 1 0 1.293 1.66 1.66 0 0 1-.374.564l-5.906 5.907a1.636 1.636 0 0 1-1.186.489 1.61 1.61 0 0 1-1.2-.489 1.62 1.62 0 0 1-.482-1.193c0-.474.16-.872.482-1.192l4.718-4.732Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};